<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <h4 class="text-h4">Suppliers</h4>
                <p class="text-subtitle-1">Suppliers List</p>
                <v-divider></v-divider>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="3" v-if="hasPermission(perm.supplier.create)">
                <v-btn block color="primary" @click="handleNewSupplier">
                    <v-icon left>mdi-plus</v-icon>
                    new supplier
                </v-btn>
            </v-col>
            <v-col cols="12" md="3">
                <v-menu offset-y :close-on-content-click="false">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            v-bind="attrs"
                            v-on="on"
                            block
                            depressed
                            >
                            <v-icon left>mdi-magnify</v-icon>
                            Search
                        </v-btn>
                    </template>
                    <v-card 
                        flat
                        >
                        <v-card-title>Search</v-card-title>
                        <v-card-text>
                            <SupplierListSearch ref="form"/>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn depressed color="primary" block @click="$refs.form.submit()">Submit</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-menu>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <SupplierList/>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import permissions from './../../data/permissions'
import SupplierListSearch from './../../components/purchase/SupplierListSearch.vue'
import SupplierList from './../../components/purchase/SupplierList.vue'
import { mapActions, mapGetters } from 'vuex';

export default {
    name: "SupplierListView",
    components: {
        SupplierList,
        SupplierListSearch
    },
    data() {
        return {
            perm: permissions
        }
    },
    computed: {
        ...mapGetters({
            hasPermission: "authentication/hasPermission"
        })
    },
    methods: {
        handleNewSupplier() {
            this.$router.push({ name: "SupplierCreate"})
        },
        ...mapActions({
            search: "purchase/supplier/list/search"
        }),
    }
}
</script>

<style>

</style>